import { type RefObject, useEffect, useState } from 'react'

export const useIsOnScreen = (
  ref: RefObject<HTMLElement>,
  root?: RefObject<HTMLElement>,
  rootMargin = '0px',
) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const rootElement = root?.current ?? null

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting)
      },
      { root: rootElement, rootMargin, threshold: 0.5 },
    )

    const currentElement = ref?.current

    if (currentElement) {
      observer.observe(currentElement)
    }

    return () => {
      if (currentElement) observer.unobserve(currentElement)
    }
  })

  return isVisible
}
